import { ChangeDetectorRef, Component, Input } from '@angular/core';
import { Style } from '@local/client-contracts';
import { isNativeWindow } from '@local/common-web';
import { UiIconModel } from '@local/ui-infra';
import moment from 'moment';
import { BrowserTabItem } from '../../models/results-types';
import { getDefaultProfile } from '@shared/utils/set-icon.util';

@Component({
  selector: 'browser-tab-item',
  templateUrl: './browser-tab-item.component.html',
  styleUrls: ['./browser-tab-item.component.scss'],
})
export class BrowserTabItemComponent {
  private _model: BrowserTabItem;

  public get model(): BrowserTabItem {
    return this._model;
  }
  @Input()
  public set model(value: BrowserTabItem) {
    this._model = value;
    this.setIcon();
    this.setTimeAgo(value.activateTime);
    this.setProfilePicture();
  }
  @Input() selected: boolean;
  modelIcon: UiIconModel;
  timeAgo: string;
  profilePicture: Style.EntityIcon<Style.EntityIconType>;

  isNative = isNativeWindow();
  readonly MEMBER_ICON_FALLBACK = getDefaultProfile();

  get showProfileIndication() {
    return this.profilePicture || this.isNative;
  }

  constructor(private cdr: ChangeDetectorRef) {}

  private setTimeAgo(activateTime: number) {
    this.timeAgo = moment(activateTime).fromNow();
    this.cdr.markForCheck();
  }

  private setIcon() {
    if (this.model.icon?.length) {
      this.modelIcon = { type: 'img', value: { lightUrl: this.model.icon } };
    } else {
      this.modelIcon = { type: 'font', value: 'icon-cards' };
    }
    this.cdr.markForCheck();
  }

  private setProfilePicture() {
    if (this.model.profile?.pictureFileName) {
      const value: Style.Icon = { lightUrl: this.model.profile?.pictureFileName };
      this.profilePicture = { type: 'img', value };
      this.cdr.markForCheck();
    }
  }
}
